export interface HeaderDisplayState {
  mobileViewPort: boolean;
  smallView?: boolean;
}

export enum HeaderDisplayCommits {
  SET_HEADER_DISPLAY = 'SET_HEADER_DISPLAY',
}
